// extracted by mini-css-extract-plugin
export default {"back":"PopupWrapper_back__xuOqN","modal":"PopupWrapper_modal__Wlx6F","wideModal":"PopupWrapper_wideModal__9j60O","closeIcon":"PopupWrapper_closeIcon__nTSTI"};